module.exports = __webpack_public_path__ + "static/img/pay_success_icon@3x.7f5e3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_success_icon@3x.png
// module id = 2h4D
// module chunks = 1